import React from 'react';
import { Tool } from '.';
import { HBox } from '../layout';
import { intl } from '../../lib';

interface MobileHeaderProps {
  title: string | React.JSX.Element;
  backAction?: () => void;
}

export function MobileHeader({
  title,
  backAction
}: Readonly<MobileHeaderProps>): React.JSX.Element {
  return (
    <header className="ehs-mobile-header">
      <HBox className="mobile-header-bar sh-font">
        {backAction && (
          <Tool
            onClick={backAction}
            icon="materialicon-chevron_left"
            text=""
            tooltip={intl('view.button.back')}
          ></Tool>
        )}
        {title &&
          (typeof title === 'string' ? (
            <h2 className="title font-18 text-ellipsis">{title}</h2>
          ) : (
            title
          ))}
        {backAction && <div className="centering-div" />}
      </HBox>
    </header>
  );
}
